/*
  Logic below is as follows: if a wide-screen device, such as a laptop or a desktop,
  is in portrait mode - its screen is rotated. However, if it is in portrait mode
  and its screen is not rotated - then it's a hand-held device, such as a smartphone
  For devices with screens more narrow than 800 pixels, whether rotated or not,
  we want to render mobile, because desktop UI will simply not fit on them
*/
export function IsMobile() {
  const hasVeryNarrowScreen = (window.innerWidth < 800);
  //const hasNarrowScreen = (window.innerWidth < 1024); // works but isn't needed rn
  if (hasVeryNarrowScreen) {
    //console.log("very narrow: true");
    //return true;
  }

  const hasMobileUseragent = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const lacksOrientationAPI = (!window.screen.orientation); // Safari and IE; maybe some other browsers on iPhones
  if (lacksOrientationAPI && hasMobileUseragent)
    return true;
  else if (lacksOrientationAPI)
    return false;

  const screenRotated = (window.screen.orientation.angle !== 0);
  const screenInPortraitMode = (/portrait/i.test(window.screen.orientation.type));
  const notOnDesktop = ((screenRotated && !screenInPortraitMode) || (!screenRotated && screenInPortraitMode));
  return notOnDesktop;
}